import { useReactiveVar } from "@apollo/client";
import React from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import {
  isEmailVerificationSentVar,
  isVerificationToastShowVar,
  notificationVerifyEmailModalVar,
} from "../../../graphql/globalVar/state";
import { useSendOrganizerVerifyEmailMutation } from "../../../graphql/profiile/profile.hooks";
import { useAuthService } from "../../../services/authService";
import Loading from "../../ui/spinner/Loading";

export default function NotificationVerifyEmailModal() {
  const { t } = useTranslation();
  const show = useReactiveVar(notificationVerifyEmailModalVar);
  const isVerificationSent = useReactiveVar(isEmailVerificationSentVar);
  const { email } = useAuthService();
  const [verifyEmail, { loading }] = useSendOrganizerVerifyEmailMutation();

  const handleClose = () => notificationVerifyEmailModalVar(false);

  const handleVerifyEmail = async () => {
    try {
      await verifyEmail();
      isEmailVerificationSentVar(true);
      isVerificationToastShowVar(true);
      notificationVerifyEmailModalVar(false);
    } catch {}
  };

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        contentClassName="rounded-4 border-0"
      >
        <Modal.Header closeButton className="border-0 px-3 pt-3 pb-0">
          <Modal.Title className="fw-bold fs-5">
            {t("emailVerify.modal.title")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-4 py-3 text-center">
          <p className="text-dark fs-6 mb-3">{t("emailVerify.modal.body")}</p>
          <p className="text-dark fs-6 mb-0">
            {t("emailVerify.modal.emailHint", { email })}
          </p>
        </Modal.Body>
        <Modal.Footer className="border-0 p-2 pt-0">
          <Button
            variant="success"
            className="w-100 rounded-3 py-3 text-white fw-bold"
            disabled={loading || isVerificationSent}
            onClick={handleVerifyEmail}
          >
            {loading ? <Loading size="sm" /> : t("emailVerify.modal.verify")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
